module.exports = __webpack_public_path__ + "img/z6.c066cf5e.png";